import React, { useState, useEffect } from "react";
import { Link, RouterProps, useHistory } from "react-router-dom";
import {
  Center,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  CloseButton,
  Text,
  Flex,
  VStack,
  Box,
  Image
} from "@chakra-ui/react";
import { Formik, Form, Field, FieldProps } from "formik";
import * as Yup from "yup";
import { forgetPassword } from "../../utils/auth-api";
import backgroundImage from "../../assets/images/Background.png";
import lockIcon from "../../assets/images/PNGs/Lock icon.png";

type FormValuesProps = {
  email: string;
};

interface ErrormessageType {
  message: string;
}

interface ErrorType {
  errors: Array<ErrormessageType>;
}

export const ForgetPassword = (_props: RouterProps) => {
  const [error, setError] = useState<ErrormessageType | null>(null);
  const [success, setSuccess] = useState(false);
  let history = useHistory();

  useEffect(() => {
    let timerId: unknown = null;
    if (error) {
      timerId = setTimeout(() => {
        setError(null);
      }, 30000);
    }
    return () => {
      clearTimeout(timerId as any);
    };
  }, [error]);
  return success ? (
    <Center height="100%">
      <Alert
        status="success"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
        width="600px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Reset password email has been sent
        </AlertTitle>
        <AlertDescription maxWidth="sm">
          Please follow the instructions in the email to reset your password.
        </AlertDescription>
      </Alert>
    </Center>
  ) : (
    <Flex
      w="100%"
      h="100%"
      backgroundImage={backgroundImage}
      backgroundSize="cover"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <VStack
        height="500px"
        width="500px"
        spacing={"6"}
        justifyContent="center"
        alignItems="center"
        bg="white"
        p="12"
        rounded={5}
        boxShadow="lg"
      >
        <Heading fontSize={"24px"} color="#05103D">
          Forgot password?
        </Heading>
        <Text fontSize={"13px"}>Please enter your email below.</Text>

        <Formik<FormValuesProps>
          initialValues={{
            email: ""
          }}
          validationSchema={Yup.object({
            email: Yup.string().email("Enter proper email")
          })}
          onSubmit={async values => {
            try {
              await forgetPassword(values.email);
              setSuccess(true);
            } catch (e) {
              const event = e as ErrormessageType;

              setError(e as ErrormessageType);
            }
          }}
        >
          {() => {
            return (
              <Form style={{ width: "100%" }}>
                <Stack width="100%" spacing="7">
                  <Field name="email">
                    {({ field, form }: FieldProps) => (
                      <FormControl
                        isInvalid={
                          form.errors.email !== undefined &&
                          form.touched.email !== undefined
                        }
                        isRequired
                      >
                        <FormLabel fontSize={"13px"}>Email address</FormLabel>
                        <Input
                          {...field}
                          id="email"
                          fontSize={"13px"}
                          placeholder="Enter email address"
                          name="email"
                        />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Image
                    alignSelf="center"
                    w="30px"
                    h="30px"
                    src={lockIcon}
                  ></Image>
                  <Text alignSelf="center" fontSize={"13px"}>
                    A password reset code will be sent to your email.
                  </Text>
                  {error ? (
                    <Alert
                      background={"none"}
                      color={"red"}
                      fontSize={"13px"}
                      status="error"
                      p={"0px"}
                    >
                      {error}{" "}
                    </Alert>
                  ) : null}
                  <Button
                    type="submit"
                    color="white"
                    bg="#2a9df4"
                    rounded="3"
                    _hover={{
                      background: "#95c7e3e8"
                    }}
                    fontSize={"13px"}
                  >
                    Verify email
                  </Button>
                </Stack>
              </Form>
            );
          }}
        </Formik>
        <Box mt="8" fontSize={"13px"}>
          Back to{" "}
          <Link to="" onClick={() => history.goBack}>
            <Text color="primary" display="inline">
              login
            </Text>
          </Link>
        </Box>
      </VStack>

      <VStack
        position="absolute"
        top="40%"
        right="12%"
        color="primary"
        opacity="15%"
        alignItems="start"
      >
        <Heading size="xl">My</Heading>
        <Heading size="xl">People</Heading>
        <Heading size="xl">Strategy</Heading>
      </VStack>
    </Flex>
  );
};
